import React, { useEffect, useRef, useState } from 'react'
import './Logo.css'

const FULL_DEV = '.dev'

const randomBetween = (min, max) => Math.random() * (max - min) + min

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

const Logo = ({ animated = false, className = '' }) => {
  const [devText, setDevText] = useState(FULL_DEV)
  const timeoutRef = useRef(null)

  useEffect(() => {
    if (!animated || prefersReducedMotion()) return undefined

    const scheduleNext = (fn, delay) => {
      timeoutRef.current = setTimeout(fn, delay)
    }

    const type = (text) => {
      if (text.length === FULL_DEV.length) {
        setDevText(text)
        scheduleNext(runCycle, randomBetween(2600, 3800))
        return
      }
      setDevText(text)
      const typeSpeed = randomBetween(130, 240)
      scheduleNext(() => type(FULL_DEV.slice(0, text.length + 1)), typeSpeed)
    }

    const erase = (text) => {
      if (text.length === 0) {
        scheduleNext(() => type(''), randomBetween(350, 600))
        return
      }
      setDevText(text)
      const eraseSpeed = randomBetween(90, 170)
      scheduleNext(() => erase(text.slice(0, -1)), eraseSpeed)
    }

    function runCycle() {
      scheduleNext(() => erase(FULL_DEV), randomBetween(2600, 3800))
    }

    runCycle()
    return () => clearTimeout(timeoutRef.current)
  }, [animated])

  return (
    <span className={`site-logo ${className}`}>
      <span className="site-logo-jarder">jarder</span>
      <span className="site-logo-dev">
        {devText}
        <span
          className={`site-logo-cursor${animated ? '' : ' static'}`}
          aria-hidden="true"
        />
      </span>
    </span>
  )
}

export default Logo
